// Angular
import { Component, OnInit, Input } from '@angular/core';

// Services
import { AdminService } from 'src/app/services/admin/admin.service';
import { MessagesService } from 'src/app/services/message/messages.service';
import { EventsService } from 'src/app/services/events/events.service';

// Others
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-user-delete',
  templateUrl: './user-delete.component.html',
  styleUrls: ['./user-delete.component.less']
})
export class UserDeleteComponent implements OnInit {
  @Input() userDetails;
  public showElem = true;

  constructor(private admin: AdminService, private msg: MessagesService, private activeModal: NgbActiveModal,
    private events: EventsService, private load: NgxSpinnerService) { }

  ngOnInit() {
    if (this.userDetails.from === 'admins') {
      this.showElem = false;
    }
  }

  // closes the modal
  public closeModal() {
    this.activeModal.close();
  }

  // delete a user
  public deleteUser() {
    const from = this.userDetails.from;
    
    // delete the user if user
    if (from === 'users') {
      const userid = this.userDetails.data.user_id;
      
      this.admin.deleteTheUser(userid)
        .then(msg => this.success(msg, userid, from))
        .catch(err => this.error(err));
    }

    // delete the admin if admin
    if (from === 'admins') {
      const adminid = this.userDetails.data.admin_id;

      this.admin.deleteTheAdmin(adminid)
        .then(msg => this.success(msg, adminid, from))
        .catch(err => this.error(err));
    }
  }

  // handle success
  private success(msg, userid, from) {
    this.load.show();
    this.msg.success(msg);
    this.events.triggerTableReload(userid, from, 'delete', {});
    this.activeModal.close({ user: userid, task: 'delete', success: true });
  }

  // handle error
  private error(msg) {
    this.load.hide();
    this.msg.error(msg);
  }
}
